<template>
    <div>
        <section class="itb-hero-cards pb-0">
            <div class="container">
                <div class="itb-hero-card itb-grey row mx-0">
                    <div class="col-12">
                        <h2 class="mb-0">
                            {{ $t("constants.playhop.grey_area_title_1") }}
                        </h2>

                        <img
                            style="display: block; margin-left: auto; margin-right: auto;"
                            class="itb-playhop-logo"
                            src="images/logo-playhop.webp"
                            alt="logo-playhop"
                        />

                        <h2 class="mb-0">
                            {{ $t("constants.playhop.grey_area_title_2") }}
                        </h2>
                        <p class="itb-playhop-greyarea-subtitle mt-5">
                            {{ $t("constants.playhop.grey_area_subtitle_1") }}
                        </p>
                        <p class="itb-playhop-greyarea-text">
                            {{ $t("constants.playhop.grey_area_text_1") }}
                        </p>
                        <p class="itb-playhop-greyarea-subtitle">
                            {{ $t("constants.playhop.grey_area_subtitle_2") }}
                        </p>
                        <p class="itb-playhop-greyarea-text">
                            {{ $t("constants.playhop.grey_area_text_2") }}
                        </p>
                        <p class="itb-playhop-greyarea-subtitle">
                            {{ $t("constants.playhop.grey_area_subtitle_3") }}
                        </p>
                        <p class="itb-playhop-greyarea-text">
                            {{ $t("constants.playhop.grey_area_text_3") }}
                        </p>
                        <p class="itb-playhop-greyarea-subtitle">
                            {{ $t("constants.playhop.grey_area_subtitle_4") }}
                        </p>
                        <p class="itb-playhop-greyarea-text">
                            {{ $t("constants.playhop.grey_area_text_4") }}
                        </p>
                        <p class="itb-playhop-greyarea-subtitle">
                            {{ $t("constants.playhop.grey_area_subtitle_5") }}
                        </p>
                        <p class="itb-playhop-greyarea-text mb-5">
                            {{ $t("constants.playhop.grey_area_text_5") }}
                        </p>
                    </div>
                </div>
            </div>
        </section>
        <hero-cards :cards="heroCards1" class="pb-0"></hero-cards>
        <section class="itb-hero-cards">
            <div class="container">
                <div
                    class="itb-hero-card row d-flex align-content-center mx-0 itb-lazy-loading-bg"
                    v-lazy:background-image="
                        !isResponsive
                            ? 'images/articles/playhop-2.webp'
                            : '/images/articles/blank-bg.webp'
                    "
                    style="background-size: cover"
                >
                    <div
                        v-if="isResponsive"
                        class="itb-hero-responsive-image"
                        v-lazy:background-image="
                            'images/articles/playhop-2.webp'
                        "
                    ></div>
                    <div class="col-12 px-0">
                        <div
                            id="itb-playhop-card"
                            class="itb-card ml-auto right"
                            style="width: 39rem"
                        >
                            <h2>
                                {{ $t("constants.playhop.card_list_title") }}
                            </h2>

                            <ol class="pl-4">
                                <li class="itb-playhop-card-list-numeral">
                                    <div class="itb-playhop-card-list">
                                        {{
                                            $t(
                                                "constants.playhop.card_list_item_1"
                                            )
                                        }}
                                    </div>
                                    <a
                                        :href="playhopCatalogueLink"
                                        target="_blank"
                                        class="btn itb-btn-icon btn-primary"
                                    >
                                        {{
                                            $t(
                                                "constants.playhop.card_list_item_1_button"
                                            )
                                        }}
                                        <img
                                            src="/images/icons/4soft_icon_angle-right.svg"
                                            :alt="
                                                $t('general.button') +
                                                    ' ' +
                                                    $t(
                                                        'realizations.show_realizations'
                                                    )
                                            "
                                            class="itb-icon itb-angle-right-icon"
                                        />
                                    </a>
                                </li>

                                <li class="itb-playhop-card-list-numeral">
                                    <div class="itb-playhop-card-list">
                                        <span>{{
                                            $t(
                                                "constants.playhop.card_list_item_2"
                                            )
                                        }}</span>
                                        <span style="font-weight: 600;"
                                            >&nbsp;nabidky@4soft.cz</span
                                        >
                                        <span
                                            >&nbsp;{{
                                                $t(
                                                    "constants.playhop.card_list_item_2_1"
                                                )
                                            }}</span
                                        >
                                    </div>

                                    <button
                                        class="btn itb-btn-icon btn-primary"
                                        @click="
                                            scrollToElement('itb-contact-form')
                                        "
                                    >
                                        {{
                                            $t(
                                                "constants.playhop.card_list_item_2_button"
                                            )
                                        }}
                                        <img
                                            src="/images/icons/4soft_icon_angle-down.svg"
                                            :alt="
                                                $t(
                                                    'realizations.i_want_proposal_free'
                                                )
                                            "
                                            class="itb-icon itb-angle-down-icon"
                                        />
                                    </button>
                                </li>

                                <li class="itb-playhop-card-list-numeral">
                                    <div class="itb-playhop-card-list">
                                        {{
                                            $t(
                                                "constants.playhop.card_list_item_3"
                                            )
                                        }}
                                    </div>
                                    <router-link
                                        :to="{
                                            name: 'contact',
                                            params: {
                                                scrollToElementId:
                                                    'itb-contacts-first-section'
                                            }
                                        }"
                                        class="btn itb-btn-icon btn-primary"
                                    >
                                        {{
                                            $t(
                                                "constants.playhop.card_list_item_3_button"
                                            )
                                        }}
                                        <img
                                            src="/images/icons/4soft_icon_angle-right.svg"
                                            :alt="
                                                $t('general.button') +
                                                    ' ' +
                                                    $t(
                                                        'realizations.show_realizations'
                                                    )
                                            "
                                            class="itb-icon itb-angle-right-icon"
                                        />
                                    </router-link>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    data() {
        return {
            heroCards1: [],
            pageParams: [],
            isResponsive: false,
            playhopCatalogueLink: ""
        };
    },

    created() {
        this.onResize();
        window.addEventListener("resize", this.onResize);
    },

    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },

    mounted() {
        axios
            .get(`/getPlayhopPage`)
            .then(response => {
                this.heroCards1 = response.data.heroCards1;
                // this.heroCards2 = response.data.heroCards2;

                this.playhopCatalogueLink = response.data.playhopCatalogueLink;

                this.pageParams = response.data.params;
                this.pageParams.contactFormTitle = this.$t(
                    "playhop.contact_form_title"
                );

                this.setPageParams(this.pageParams);
            })
            .catch(error => {
                console.log(error);
            });
    },

    computed: {
        ...mapGetters({
            appParams: "getAppParams"
        })
    },

    methods: {
        ...mapActions(["setPageParams"]),
        scrollToElement(elementId) {
            this.$parent.scrollToElement(elementId);
        },

        onResize() {
            if (window.innerWidth < 992) {
                this.isResponsive = true;
            } else {
                this.isResponsive = false;
            }
        }
    }
};
</script>
